import { render, staticRenderFns } from "./CsoProcurementCost.vue?vue&type=template&id=e5e5212a&scoped=true"
import script from "./CsoProcurementCost.vue?vue&type=script&lang=js"
export * from "./CsoProcurementCost.vue?vue&type=script&lang=js"
import style0 from "./CsoProcurementCost.vue?vue&type=style&index=0&id=e5e5212a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5e5212a",
  null
  
)

export default component.exports